<template>
  <!-- Explore by Country section for homepage -->
  <div id="explore-country-container">
    <!-- Loading indicator -->
    <a v-if="!loaded" name="explore-by-country">
      <LoaderComponent />
    </a>
    <div v-else id="explore-country-loader-wrapper">
      <div id="explore-country">
        <div id="explore-country-header">
          <a name="explore-by-country">Explore by Country</a>
        </div>
        <div
          id="explore-country-description"
          v-html="exploreByCountryDescription"
        ></div>
        <div id="explore-country-map-container">
          <!-- Google Map container (code for loading is in methods) -->
          <div id="explore-country-map"></div>
          <!-- Dropdown containing all Countries -->
          <div id="explore-country-dropdown-container">
            <select
              id="explore-country-dropdown"
              v-model="country"
              @change="goToCountry($event.target.selectedOptions[0].id)"
            >
              <option selected disabled value="">Select a Country</option>
              <option
                v-for="country in countries"
                :key="country.countryId"
                :value="country.countryName"
                :id="country.countryId"
              >
                {{ country.countryName }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoaderComponent from "./LoaderComponent.vue";
import truncate from "../mixins/truncate.js";
import language from "../mixins/language.js";
import homepageTexts from "../mixins/homepageTexts.js";
export default {
  name: "ExploreCountry",
  components: {
    LoaderComponent: LoaderComponent,
  },
  mixins: [truncate, language, homepageTexts],
  data() {
    return {
      exploreByCountryDescription: "",
      countries: [],
      highlighted: [],
      map: {},
      countryId: "",
      country: "",
      countryDescription: "",
      selectionMade: false,
      loaded: false,
    };
  },
  methods: {
    getCountries: function () {
      axios({
        method: "GET",
        url: `${process.env.VUE_APP_API_ENDPOINT}/countries`,
      }).then(
        (result) => {
          let results = result.data;
          let array = [];
          // Save relevant information into new array
          for (let i = 0; i < results.length; i++) {
            let country = {};
            country.countryId = results[i].countryId;
            country.countryName = this.returnValueInLanguage(
              "en",
              results[i].countryName
            ).value;
            country.countryDescription = this.truncate(
              400,
              this.returnValueInLanguage("en", results[i].countryDescription)
                .description
            );
            country.geoCoordinates = results[i].geoCoordinates;
            country.image = results[i].countryImage;
            array.push(country);
          }
          // Sort alphabetically
          array.sort(function (a, b) {
            let nameA = a.countryName;
            let nameB = b.countryName;
            return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
          });
          this.countries = array;
          this.loaded = true;
          // Get random Countries for highlighting
          this.highlight(this.countries);
          this.$nextTick(() => {
            this.generateMap(this.countries);
          });
        },
        (error) => {
          console.error(error);
        }
      );
    },

    highlight: function (array) {
      let countries = array.slice();
      // Empty the highlighted array
      this.highlighted = [];
      // Shuffle the array
      // https://stackoverflow.com/a/962890
      let tmp,
        current,
        top = countries.length;
      if (top)
        while (--top) {
          current = Math.floor(Math.random() * (top + 1));
          tmp = countries[current];
          countries[current] = countries[top];
          countries[top] = tmp;
        }
      // Push the first four "random" Countries into the highlighted array
      for (let i = 0; i < 4; i++) {
        this.highlighted.push(countries[i]);
      }
    },
    generateMap: function (array) {
      // Center: Somewhere in Italy
      // LatLngBounds (below) should take care of centering and zoom
      let coordinates = { lat: 41.37462, lng: 16.232481 };
      // Create a new Google Maps object
      this.map = new google.maps.Map(
        document.getElementById("explore-country-map"),
        {
          center: coordinates,
          mapTypeId: "hybrid",
          styles: [
            {
              featureType: "poi",
              elementType: "labels.text",
              stylers: [
                {
                  visibility: "off",
                },
              ],
            },
            {
              featureType: "poi.business",
              stylers: [
                {
                  visibility: "off",
                },
              ],
            },
            {
              featureType: "road",
              elementType: "labels.icon",
              stylers: [
                {
                  visibility: "off",
                },
              ],
            },
            {
              featureType: "transit",
              stylers: [
                {
                  visibility: "off",
                },
              ],
            },
          ],
        }
      );

      let infoWindow = new google.maps.InfoWindow();
      let marker, z;
      let bounds = new google.maps.LatLngBounds();
      // Array is this.countries
      // Create a marker for each country
      for (z = 0; z < array.length; z++) {
        let geo = array[z].geoCoordinates;
        marker = new google.maps.Marker({
          position: new google.maps.LatLng(geo.latitude, geo.longitude),
          map: this.map,
          icon: require("../assets/pointer.png"),
        });
        bounds.extend(marker.position);
        // Inside for loop for creating markers, also add a listener for each one, containing that country's info
        google.maps.event.addListener(
          marker,
          "click",
          ((marker, z) => {
            return () => {
              this.countryId = array[z].countryId;
              this.country = array[z].countryName;
              let text = `
              <div>
                <a href="/countries/c-${array[z].countryId}">
                  ${array[z].countryName}
                </a>
              </div>
            `;
              infoWindow.setContent(text);
              infoWindow.open(this.map, marker);
              this.map.panTo(
                new google.maps.LatLng(geo.latitude, geo.longitude)
              );
            };
          })(marker, z)
        );
      }
      this.map.fitBounds(bounds);
    },
    // When Country is selected in dropdown, update data for Google Map
    selected: function (index, id) {
      this.selectionMade = true;
      this.countryId = id;
      this.countryDescription = this.countries[index].countryDescription;
      let coords = this.countries[index].geoCoordinates;
      this.map.panTo(new google.maps.LatLng(coords.latitude, coords.longitude));
    },
    goToCountry: function (id) {
      this.$router.push({ name: "countries", params: { country: `c-${id}` } });
    },
  },
  mounted() {
    this.getTexts("exploreByCountryDescription", "Home-Explore-by-Country");
    this.getCountries();
  },
};
</script>

<style scoped lang="scss">
.loader-container {
  height: 700px;
}

#explore-country-container {
  width: 100%;
  padding: 0 40px;
}

#explore-country-header {
  @include headings;
  @include font-size-1;
  margin-bottom: 30px;
}
#explore-country-header a {
  cursor: default;
}
#explore-country-header a:hover {
  text-decoration: none;
}
#explore-country-description {
  @include texts;
  @include font-size-4;
  color: $medium-dark-grey;
  margin-bottom: 20px;
}

#explore-country-map-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid $light-grey;
  box-shadow: 0 2px 8px 2px $light-grey;
  padding: 30px;
  margin-bottom: 30px;
}
#explore-country-map {
  height: 600px;
  width: 100%;
}
#explore-country-panel {
  height: 100%;
  width: 35%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
#explore-country-dropdown-container {
  width: 100%;
  margin-top: 30px;
}
#explore-country-dropdown {
  @include font-size-6;
  width: 100%;
  background-color: $background-color;
  border: 1px solid $medium-light-grey;
  border-radius: 5px;
  box-shadow: inset 0px 1px 4px rgba(0, 0, 0, 0.25);
  padding: 8px 15px;
}
#explore-country-info-container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.explore-country-info {
  @include flex-center;
  flex-direction: column;
}
.explore-country-name {
  @include headings;
  @include font-size-1;
  text-align: center;
  color: $dark-green;
  margin-bottom: 20px;
}
.explore-country-description {
  @include texts;
  @include font-size-5;
  width: 100%;
  color: $medium-dark-grey;
}
.explore-country-description :deep(*) {
  @include texts;
  @include font-size-5;
  color: $medium-dark-grey;
}
#explore-country-info a {
  width: 100%;
}
#explore-country-button-link {
  margin-bottom: 15px;
}
#explore-country-button {
  @include primary-button;
  height: 40px;
  width: 100%;
  border-radius: 10px;
}
#explore-country-button:disabled {
  background-color: $medium-light-grey;
  cursor: default;
}

@media only screen and (max-width: 1199px) {
  #explore-country-header {
    @include font-size-2;
  }
  #explore-country-description {
    @include font-size-5;
  }
}

@media only screen and (max-width: 599px) {
  #explore-country-map-container {
    padding: 15px;
    margin-bottom: 15px;
  }
  #explore-country-map {
    height: 475px;
  }
}

@media only screen and (max-width: 499px) {
  #explore-country-header {
    @include font-size-4;
    margin-bottom: 20px;
  }
  #explore-country-description {
    @include font-size-6;
  }
  #explore-country-map {
    height: 400px;
  }
}
</style>
